import api from '../../api'
import _ from 'lodash'
import moment from 'moment-timezone'
import { getFare, getCharge, getTextValue, getFreePass, getFareAndCharge } from '../../utils/price.js'
moment.tz.setDefault('Asia/Tokyo')

const getDefaultState = () => {
  return {
    all: [],
    error: false
  }
}

const state = getDefaultState

const getters = {
  getAll: (state) => state.all,
  isError: (state) => state.error,
  getTotalFare: (state) => {
    var total = 0;
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].course !== undefined) {
        total += getFare(state.all[i].course);
      }
    }
    return total;
  },
  getTotalCharge: (state) => {
    var total = 0;
    for (var i = 0; i < state.all.length; i++) {
      if (state.all.course !== undefined) {
        total += getCharge(state.all[i].course);
      }
    }
    return total;
  },
  getUseTaxi: (state) => {
    let useTaxi = false;
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].course !== undefined) {
        var prices = state.all[i].course.Price;
        if (prices !== undefined) {
          for (var j = 0; j < prices.length; j++) {
            if (prices[j].kind == "Fare" && prices[j].selected == "true") {
              var lineIndex = parseInt(prices[j].fromLineIndex, 10) - 1;
              if (getTextValue(state.all[i].course.Route.Line[lineIndex].Type) == "car") {
                useTaxi = true;
              }
            }
          }
        }
      }
    }
    return useTaxi;
  },
  getTotalFareAndCharge: (state) => {
    var TotalFareAndCharge = {};
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].course !== undefined) {
        const set = getFareAndCharge(state.all[i].course)
        Object.keys(set).forEach(function (key) {
          if (TotalFareAndCharge[key] == undefined) TotalFareAndCharge[key] = 0
          TotalFareAndCharge[key] += set[key]
        })
      }
    }
    return TotalFareAndCharge
  },
  getTotalFreePass: (state) => {
    var totalSet = {};
    for (var i = 0; i < state.all.length; i++) {
      if (state.all[i].course !== undefined) {
        const set = getFreePass(state.all[i].course)
        Object.keys(set).forEach(function (key) {
          if (totalSet[key] == undefined) totalSet[key] = {}
          if (totalSet[key]['name'] == undefined) totalSet[key]['name'] = set[key]['name']
          if (totalSet[key]['freePassPrice'] == undefined) totalSet[key]['freePassPrice'] = set[key]['freePassPrice']
          if (totalSet[key]['otherPrice'] == undefined) totalSet[key]['otherPrice'] = 0
          totalSet[key]['otherPrice'] += set[key]['otherPrice']
        });
      }
    }
    return totalSet
  }
}

const actions = {
  search ({ commit, dispatch, rootGetters }) {
    const condition = rootGetters['condition/getOptions']
    const base = rootGetters['destinations/getAll'].find(d => d.lock)
    const prev = rootGetters['destinations/getDestination'](base.index - 1)
    const next = rootGetters['destinations/getDestination'](base.index + 1)

    commit('resetState')

    // 基準の目的から前の行程は到着時間をベースに再帰的に検索
    const profile = rootGetters['user/getProfile']
    let baseTime = base.baseStartTime ? base.baseStartTime : '10:00'
    if (base.baseStartTime.length == 4) {
      // iOSの場合、時刻が0埋めされていないとmoment.jsでエラーになる
      baseTime = '0' + baseTime
    }
    const t = moment(profile.depDate + ' ' + baseTime)
    dispatch('searchArrivalBase', {
      from: prev,
      to: base,
      time: _.cloneDeep(t),
      taxiDistance: condition.taxiDistance,
      sort: condition.sort
    })

    // 基準の目的から後の行程は出発時間をベースに再帰的に検索
    dispatch('searchDepartureBase', {
      from: base,
      to: next,
      time: _.cloneDeep(t).add(base.visit, 'minutes'),
      taxiDistance: condition.taxiDistance,
      sort: condition.sort
    })
  },
  searchArrivalBase({ commit, dispatch, rootGetters }, params) {
    const profile = rootGetters['user/getProfile']
    let p = Object.assign({ searchType: 'arrival', flightNumber: profile.depFlightNumber + ":" + profile.arrFlightNumber, useTaxi: profile.useTaxi, useCycle: profile.useCycle }, params)

    // 最初の目的地であればfromに出発駅をセットしてその間の経路を検索
    if (!p.from) {
      const departure = rootGetters['destinations/getDepatureStation']
      p = { ...p, from: departure }
    }
    dispatch('loading/beginLoading', {}, { root: true })
    api.searchRoute(p, rootGetters['user/getLang'])
      .then((route) => {
        if (params.from) {
          const prev = rootGetters['destinations/getDestination'](params.from.index - 1)
          const time = _.cloneDeep(route.points[0].departureTime)

          dispatch('searchArrivalBase', {
            ...params,
            from: prev,
            to: params.from,
            time: time.subtract(params.from.visit, 'minutes')
          })
        } else {
          const location = route.points[0].location
          dispatch('destinations/updateDepartureStationLocation', location, { root: true })
        }
        commit('setRoute', route)
        dispatch('loading/endLoading', {}, { root: true })
        dispatch('destinations/updateEditable', {}, { root: true })
      })
      .catch(() => {
        commit('error')
        dispatch('loading/endLoading', {}, { root: true })
      })
  },
  searchDepartureBase({ commit, dispatch, rootGetters }, params) {
    const profile = rootGetters['user/getProfile']
    let p = Object.assign({ searchType: 'departure', flightNumber: profile.depFlightNumber + ":" + profile.arrFlightNumber, useTaxi: profile.useTaxi, useCycle: profile.useCycle }, params)

    // 最後の目的地であればtoに到着駅をセットしてその間の経路を検索
    if (!p.to) {
      const arrival = rootGetters['destinations/getArrivalStation']
      p = { ...p, to: arrival }
    }

    dispatch('loading/beginLoading', {}, { root: true })
    api.searchRoute(p, rootGetters['user/getLang'])
      .then((route) => {
        if (params.to) {
          const next = rootGetters['destinations/getDestination'](params.to.index + 1)
          var time;

          if (params.to.checkIn !== undefined) {
            time = _.cloneDeep(params.to.checkIn)
          } else {
            time = _.cloneDeep(route.points.slice(-1)[0].arrivalTime)
          }

          dispatch('searchDepartureBase', {
            ...params,
            from: params.to,
            to: next,
            time: time.add(params.to.visit, 'minutes')
          })
        } else {
          const location = route.points[route.points.length - 1].location
          dispatch('destinations/updateArrivalStationLocation', location, { root: true })
        }
        commit('setRoute', route)
        dispatch('loading/endLoading', {}, { root: true })
        dispatch('destinations/updateEditable', {}, { root: true })
      })
      .catch(() => {
        commit('error')
        dispatch('loading/endLoading', {}, { root: true })
      })
  },
  updateRoutes({ commit }, routes) {
    commit('setRoutes', routes)
  },
  resetRoutes({ commit }) {
    commit('resetState')
  },
  parseTime({ commit }) {
    commit('setRoutesMoment')
    commit('setPointsMoment')
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  reset (state) {
    state.all = []
  },
  setRoute (state, route) {
    state.all = _.sortBy(_.concat(state.all, route), ['index'])
  },
  setRoutes (state, routes) {
    state.all = routes
  },
  error (state) {
    state.error = true
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  setRoutesMoment (state) {
    state.all.forEach((r) => {
      if (r.arrivalTime && !moment.isMoment(r.arrivalTime) ) {
        r.arrivalTime = moment(r.arrivalTime)
      }
      if (r.departureTime && !moment.isMoment(r.departureTime) ) {
        r.departureTime = moment(r.departureTime)
      }
    })
  },
  setPointsMoment (state) {
    state.all.forEach((r) => {
      if (r.points) {
        r.points.forEach((p) => {
          if (p.arrivalTime && !moment.isMoment(p.arrivalTime) ) {
            p.arrivalTime = moment(p.arrivalTime)
          }
          if (p.departureTime && !moment.isMoment(p.departureTime) ) {
            p.departureTime = moment(p.departureTime)
          }
        })
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}